import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { getOurWork } from '../store/actions'
import { baseURL2 } from '../helper/helper'

export default function OurWork() {
    const dispatch = useDispatch()
    const { ourWork, loading } = useSelector((state) => state.reducer || {})
    const [activeTag, setActiveTag] = useState('')

    const tags = ['All', 'Event', 'Student', 'Social', 'Tree Plantation', 'Health', 'Construction']

    useEffect(() => {
        dispatch(getOurWork(activeTag === 'All' ? '' : activeTag))
        window.scrollTo(0, 0)
    }, [dispatch, activeTag])

    return (
        <div className="min-h-screen bg-white text-gray-900 pb-24">
            <section className="pt-32 pb-16 px-6 max-w-4xl mx-auto text-center relative">
                <div className="absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 w-64 h-64 bg-primary/5 rounded-full blur-3xl pointer-events-none"></div>
                <span className="text-xs tracking-widest uppercase text-secondary font-bold mb-6 block relative z-10">Archives of Impact</span>
                <h1 className="text-4xl md:text-6xl font-light text-primary tracking-tight leading-tight mb-8 relative z-10">
                    Our <span className="font-medium text-secondary">Chronicles</span>.
                </h1>
                <p className="text-lg md:text-xl text-gray-500 font-light max-w-2xl mx-auto leading-relaxed relative z-10">
                    Visualizing the profound impact of our multi-dimensional initiatives across education, humanity, and environmental protection.
                </p>
            </section>

            <section className="py-6 border-y border-gray-100 bg-white/95 backdrop-blur-sm sticky top-20 z-40">
                <div className="max-w-7xl mx-auto flex flex-wrap justify-center gap-3 px-6">
                    {tags.map((tag) => (
                        <button
                            key={tag}
                            onClick={() => setActiveTag(tag)}
                            className={`px-6 py-2.5 rounded-full text-[10px] font-bold uppercase tracking-[3px] transition-all duration-300 border ${(activeTag === tag || (tag === 'All' && activeTag === ''))
                                    ? 'bg-primary text-white border-primary shadow-md shadow-primary/20 scale-105'
                                    : 'bg-gray-50 text-gray-500 border-gray-100 hover:border-secondary/30 hover:text-secondary'
                                }`}
                        >
                            {tag}
                        </button>
                    ))}
                </div>
            </section>

            <section className="py-24 px-6 md:px-12 max-w-7xl mx-auto">
                {loading ? (
                    <div className="py-24 text-center">
                        <div className="w-12 h-12 border-4 border-secondary border-t-transparent rounded-full animate-spin mx-auto mb-6"></div>
                        <span className="text-primary font-bold tracking-[4px] uppercase text-xs opacity-50">Synchronizing Archives...</span>
                    </div>
                ) : ourWork?.results && ourWork.results.length > 0 ? (
                    <div className="columns-1 sm:columns-2 lg:columns-3 gap-8 space-y-8">
                        {ourWork.results.map((item, index) => (
                            <div key={index} className="break-inside-avoid relative rounded-[32px] bg-white p-1.5 shadow-sm hover:shadow-xl group transition-all duration-500">
                                <div className="relative overflow-hidden rounded-[26px] w-full h-full">
                                    <img
                                        loading="lazy"
                                        src={item.photo ? (item.photo.startsWith('http') ? item.photo : (baseURL2 + item.photo)) : "/placeholder.jpg"}
                                        alt={item.name || "Initiative"}
                                        className="w-full h-auto object-cover transition-transform duration-700 group-hover:scale-105"
                                    />
                                    <div className="absolute inset-x-0 bottom-0 p-6 bg-gradient-to-t from-primary/95 via-primary/80 to-transparent translate-y-2 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500 z-10">
                                        <span className="text-[10px] font-bold uppercase tracking-widest text-secondary block mb-2 drop-shadow-md">{item.tag}</span>
                                        <h3 className="text-lg font-medium text-white drop-shadow-sm">{item.name || "Foundation Initiative"}</h3>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="py-32 text-center bg-gray-50 rounded-[40px] border border-gray-100">
                        <h3 className="text-xl font-light text-primary mb-4">Archives Empty</h3>
                        <p className="text-gray-400 text-sm tracking-widest uppercase">
                            No work to display for this category.
                        </p>
                    </div>
                )}
            </section>
        </div>
    )
}
